[].slice.call(document.querySelectorAll('.image-slideshow .pagination button')).forEach(function(button) {
	button.addEventListener('click', function() {
		var isNext = this.classList.contains('next'),
			slidesContainer = this.parentNode.parentNode.querySelector('.slides-container'),
			slides = slidesContainer.querySelectorAll('.image-slide'),
			slidesLength = slides.length-1,
			currentIndex = parseInt(slidesContainer.querySelector('.image-slide:not([aria-hidden="true"])').dataset.index),
			nextIndex = isNext ? (currentIndex != slidesLength ? currentIndex+1 : false) : (currentIndex !== 0 ? currentIndex-1 : false),
			buttonSibling = isNext ? this.previousElementSibling : this.nextElementSibling;

		slides[0].style.marginLeft = (slides[0].offsetWidth * -nextIndex)+'px';

		slides[currentIndex].setAttribute('aria-hidden', 'true');
		slides[nextIndex].removeAttribute('aria-hidden');

		if((isNext && nextIndex == slidesLength) || (!isNext && nextIndex == 0))
			this.setAttribute('aria-hidden', 'true');
		if((isNext && currentIndex == 0) || (!isNext && currentIndex == slidesLength))
			buttonSibling.removeAttribute('aria-hidden');
	});
});